import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import UserProfile, { validName } from '../records/UserProfile';
import ProfileHeader from '../components/ProfileHeader';
import { isUserImpersonated } from '../selectors/AuthSelector';
import { isRestrictedImpersonatee } from '../selectors/IsRestrictedImpersonateeSelector';
import { getCurrentUserProfile } from '../selectors/EntitySelector';
import { getEditNamePopoverOpen } from '../selectors/InteractionSelector';
import { stageChange, clearChange } from '../actions/StagingActions';
import { PROFILE_FIRST_NAME, PROFILE_LAST_NAME } from '../constants/StagingDataKeys';
import { getIsScimUser } from '../selectors/ProfileSelector';
import { jsx as _jsx } from "react/jsx-runtime";
class ProfileHeaderContainer extends Component {
  constructor(props) {
    super(props);
    this.onStagedFirstNameChanged = this.onStagedFirstNameChanged.bind(this);
    this.onStagedLastNameChanged = this.onStagedLastNameChanged.bind(this);
  }
  onStagedFirstNameChanged(evt) {
    const {
      profile
    } = this.props;
    if (evt.target.value !== profile.get('firstName')) {
      this.props.stageChange(PROFILE_FIRST_NAME, evt.target.value);
    } else {
      this.props.clearChange(PROFILE_FIRST_NAME);
    }
  }
  onStagedLastNameChanged(evt) {
    const {
      profile
    } = this.props;
    if (evt.target.value !== profile.get('lastName')) {
      this.props.stageChange(PROFILE_LAST_NAME, evt.target.value);
    } else {
      this.props.clearChange(PROFILE_LAST_NAME);
    }
  }
  render() {
    const {
      profile,
      editNamePopoverOpen,
      isHubless,
      isScimUser
    } = this.props;
    const {
      stagedFirstName,
      stagedLastName,
      isImpersonated
    } = this.props;
    return /*#__PURE__*/_jsx(ProfileHeader
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    , {
      firstName: profile.get('firstName'),
      lastName: profile.get('lastName'),
      stagedFirstName: stagedFirstName !== undefined ? stagedFirstName : profile.get('firstName'),
      stagedLastName: stagedLastName !== undefined ? stagedLastName : profile.get('lastName'),
      validFirstName: stagedFirstName === undefined || validName(stagedFirstName),
      validLastName: stagedLastName === undefined || validName(stagedLastName),
      editNamePopoverOpen: editNamePopoverOpen,
      onStagedFirstNameChanged: this.onStagedFirstNameChanged,
      onStagedLastNameChanged: this.onStagedLastNameChanged,
      isHubless: isHubless,
      isScimUser: isScimUser,
      isImpersonated: isImpersonated
    });
  }
}
ProfileHeaderContainer.propTypes = {
  profile: PropTypes.instanceOf(UserProfile).isRequired,
  editNamePopoverOpen: PropTypes.bool.isRequired,
  isHubless: PropTypes.bool.isRequired,
  isScimUser: PropTypes.bool.isRequired,
  isImpersonated: PropTypes.bool.isRequired,
  stageChange: PropTypes.func.isRequired,
  stagedFirstName: PropTypes.string,
  stagedLastName: PropTypes.string,
  clearChange: PropTypes.func.isRequired
};
const mapStateToProps = state => {
  return {
    profile: getCurrentUserProfile(state),
    editNamePopoverOpen: getEditNamePopoverOpen(state),
    isImpersonated: isUserImpersonated(state) && !isRestrictedImpersonatee(state),
    isScimUser: getIsScimUser(state),
    stagedFirstName: state.stagedChanges.get(PROFILE_FIRST_NAME),
    stagedLastName: state.stagedChanges.get(PROFILE_LAST_NAME)
  };
};
export default connect(mapStateToProps, {
  stageChange,
  clearChange
})(ProfileHeaderContainer);